import apiClient from './apiClient';
import type { ChatMessage } from '../types';

const base = '/direct/usersvc/messages';

const MessagesAPI = {
  getThread: () => apiClient.get<ChatMessage[]>(base),
  send: (body: string) => apiClient.post<ChatMessage>(base, { message: { body } }),
  markRead: () => apiClient.post<Record<string, never>>(`${base}/read`),
  unreadCount: () => apiClient.get<{ count: number }>(`${base}/unread`),
};

export default MessagesAPI;
